import IServerIncident from './ServerIncident/IServerIncident';
import {isServerHeartbeatIncident, isServerIncidentOpen} from '../lib/serverIncidentHelper';

import {useServerIncidentDuration} from './useServerIncidentDuration';

interface IServerIncidentSummary {
    isOpen: boolean,
    isHeartbeat: boolean,
    metricLabel: string,
    serverUuid: string,
    serverName: string,
    durationSeconds: number,
}

export function useServerIncidentSummary(incident: IServerIncident): IServerIncidentSummary {
    const isOpen = isServerIncidentOpen(incident);
    const isHeartbeat = isServerHeartbeatIncident(incident);
    const durationSeconds = useServerIncidentDuration(incident);
    const {uuid: serverUuid, name: serverName} = incident.server;

    return {isOpen, isHeartbeat, metricLabel: incident.metric_label, serverUuid, serverName, durationSeconds};
}
